import { render } from "./BlockBlack.vue?vue&type=template&id=3d5c6e5b&scoped=true"
import script from "./BlockBlack.vue?vue&type=script&lang=js"
export * from "./BlockBlack.vue?vue&type=script&lang=js"

import "./BlockBlack.vue?vue&type=style&index=0&id=3d5c6e5b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d5c6e5b"]])

export default __exports__